import { FilterOption } from '@britishcouncil/react-admin';
import { getCentreFullName, getCentreValue } from 'utils/centres/centresUtils';

import { CentreTypeSelector } from 'api';
import { useGetAllCentresQuery } from 'store/centres/centresApi';
import { useMemo } from 'react';

export function useCentresOptions(
  centreType: number | undefined,
  countries?: number[] | undefined,
  regions?: number[] | undefined
): Array<FilterOption<string> & { isActive?: boolean }> {
  const { data } = useGetAllCentresQuery();

  const centres = useMemo(
    () =>
      data?.centres
        .filter(
          (centre) =>
            (countries?.length ? countries.includes(centre.countryId!) : true) &&
            (regions?.length ? regions.includes(centre.regionId!) : true) &&
            (centreType === CentreTypeSelector.ALL ||
              (centreType === CentreTypeSelector.IDP && centre.isIdp) ||
              (centreType === CentreTypeSelector.BC && !centre.isIdp))
        )
        .map((centre) => ({
          text: getCentreFullName(centre, centreType!),
          value: getCentreValue(centre.id, centre.isIdp),
          isActive: centre.isActive,
        }))
        .sort((a, b) => (a.text < b.text ? -1 : 1)) ?? [],
    [centreType, countries, data?.centres, regions]
  );

  return centres;
}
